import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'distinct'
})
export class DistinctPipe implements PipeTransform {
  constructor() {
  }

  transform<T>(inputs: T[], fn?: Function): T[] {
    const strings = (inputs || []).map(value => {
      if(fn){
        return fn(value).toString();
      }

      return (value || '').toString();
    });
    const duplicates: T[] = [];
    strings.filter((value, index) => {
      const b = strings.indexOf(value) === index;
      if (!b) {
        duplicates.push(inputs[index]);
      }
      return b;
    });

    return (inputs || []).filter(value => duplicates.indexOf(value) === -1);
  }

}
